import { createSelector } from 'reselect';

import {
  getCurrentCardInfo,
  getPdpLinks,
  getHeroDtmEvents
} from 'page_modules/business-pdp/redux';
import { getPageData } from 'src/universal/redux/page';
import { buildCtaAndLinks } from './utils';

export const getCtaAndLinks = urlEep =>
  createSelector(
    [getCurrentCardInfo, getPdpLinks(urlEep), getHeroDtmEvents],
    (cardInfo, pdpLinks, dtmEvents) => {
      return buildCtaAndLinks(cardInfo, pdpLinks, dtmEvents);
    }
  );

export const getDynAppOfferBox = createSelector(getPageData, pageData => {
  return pageData?.dynAppOfferBox;
});
